import React from 'react';
import Button from '../../../components/common/Button/Button';
import type { StudentHistoryStudent } from '../../../types/studentHistory';
import styles from './StudentHistoryHeader.module.css';

interface StudentHistoryHeaderProps {
  student: StudentHistoryStudent | null;
  fallbackName: string;
  fallbackEmail: string | null;
  onBack: () => void;
}

const StudentHistoryHeader: React.FC<StudentHistoryHeaderProps> = ({
  student,
  fallbackName,
  fallbackEmail,
  onBack,
}) => {
  const displayName = student?.full_name || fallbackName || 'Aluna';
  const displayEmail = student?.email ?? fallbackEmail;

  return (
    <header className={styles.header}>
      <div className={styles['left-content']}>
        <Button type="button" variant="outline" size="small" onClick={onBack}>
          Voltar
        </Button>
        <div className={styles['student-block']}>
          <h1 className={styles.title}>Histórico de mensagens</h1>
          <p className={styles.name}>{displayName}</p>
          {displayEmail && <p className={styles.email}>{displayEmail}</p>}
        </div>
      </div>
    </header>
  );
};

export default StudentHistoryHeader;
